__turbopack_context__.v({
  "multi_livestream__schedule__timeline": "Timeline-module-scss-module__Frh7EG__multi_livestream__schedule__timeline",
  "time_indicator": "Timeline-module-scss-module__Frh7EG__time_indicator",
  "time_slot": "Timeline-module-scss-module__Frh7EG__time_slot",
  "time_slot__day": "Timeline-module-scss-module__Frh7EG__time_slot__day",
});
